import { render, staticRenderFns } from "./ComplaintTypeAdd.vue?vue&type=template&id=c19d0142&"
import script from "./ComplaintTypeAdd.vue?vue&type=script&lang=js&"
export * from "./ComplaintTypeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports